module.exports = __webpack_public_path__ + "img/salvo_local_e_envio.3c04bd88.gif";